<ng-container #flow="flow" [flowConfig]="uploadConfig"></ng-container>
<input type="file"
       style="width: 0; height: 0"
       (click)="onFileInputClick()"
       (change)="onFileChange($event)"
       [flowAttributes]="{accept}"
       #inputFile
       flowButton
       [flow]="flow.flowJs">
@if (flow.transfers$ | async; as basic) {
  @if(basic?.transfers) {
    @for (transfer of basic.transfers; track transfer?.id) {
      <div class="content-container button-border-color">
        @if (!transfer.success) {
          <mat-spinner [diameter]="24" class="accent-color"></mat-spinner>
        } @else if (transfer.success) {
          @switch (typeFile) {
            @case ('image') {
              @if (currentFileToUpload) {
                <img [flowSrc]="transfer" alt="image" class="image">
              }
<!--              <mat-icon class="accent-color" fontSet="material-icons-outlined">photo_camera</mat-icon>-->
            }
            @case ('video') {
              @if (currentFileToUpload) {
                <img [ngSrc]="currentFileToUpload?.thumb_url || ''" fill alt="image" class="image">
                <mat-icon class="accent-color icon-position" fontSet="material-icons-outlined">videocam</mat-icon>
              }
<!--              <mat-icon class="accent-color" fontSet="material-icons-outlined">videocam</mat-icon>-->
            }
            @case ('file') {
              <mat-icon class="accent-color" fontSet="material-icons-outlined">description</mat-icon>
            }
            @case ('audio') {
              <mat-icon class="accent-color" fontSet="material-icons-outlined">volume_up</mat-icon>
            }
          }
        }
        <button class="close-button block-background button-border-color-inversion"
                [disabled]="sendLoading"
                (click)="flow.cancelFile(transfer); destroyComponent()" mat-mini-fab>
          <mat-icon class="accent-color">{{ 'close'}}</mat-icon>
        </button>
        <div class="content-type main-text-color">{{transfer.name}}</div>
        <div class="content-file-type hint-color">{{transfer.name.slice(transfer.name.lastIndexOf('.') + 1)}}</div>
      </div>
    }
  }
}


